import React, { FC, useState } from 'react';
import { View, TextInput } from 'react-native';

import { font as initialFont } from '@styles/fonts';
import { scale as initialScale } from '@components/frame';
import ModalHeader from '@components/modal/ModalHeader';
import { WithColor } from '@styles/colors';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

interface PiecesPerCycleModalProps extends WithColor {
  hide: () => void;
  currentValue: number;
  onSubmit: (value: number) => void;
  font?: typeof initialFont;
  scale?: ScaleFunction;
}

const PiecesPerCycleModal: FC<PiecesPerCycleModalProps> = ({ hide, C, currentValue, onSubmit, font = initialFont, scale = initialScale }) => {
  const [inputValue, setInputValue] = useState(String(currentValue));

  const parsed = parseInt(inputValue, 10);
  const isValid = !!inputValue && !isNaN(parsed) && parsed >= 1;

  const handleDone = () => {
    if (!isValid) return;
    onSubmit(parsed);
    hide();
  };

  return (
    <View testID={TEST_IDS.piecesPerCycleModal.root} style={{ minWidth: scale(400) }}>
      <ModalHeader
        C={C}
        title="Pieces Per Cycle"
        onCancel={hide}
        onSubmit={handleDone}
        submitDisabled={!isValid}
        submitTestID={TEST_IDS.piecesPerCycleModal.submitButton}
      />
      <View style={{ padding: scale(16), paddingTop: scale(50) }}>
        <TextInput
          testID={TEST_IDS.piecesPerCycleModal.input}
          style={[
            font.Body,
            {
              borderWidth: 1,
              borderColor: C('Hairline/Light/No trans [mobile]'),
              borderRadius: scale(8),
              padding: scale(12),
              color: C('Label/Light/Primary'),
              backgroundColor: C('Background/Light/Field lighter'),
              textAlign: 'center',
            },
          ]}
          value={inputValue}
          onChangeText={setInputValue}
          keyboardType="number-pad"
          autoFocus
          selectTextOnFocus
          onSubmitEditing={handleDone}
        />
      </View>
    </View>
  );
};

export default PiecesPerCycleModal;
